import {
  BulkCreateBudgetAllocationDocument,
  BulkCreateBudgetAllocationMutationVariables,
  BulkDeleteBudgetAllocationDocument,
  BulkDeleteBudgetAllocationMutationVariables,
  BulkUpdateBudgetAllocationDocument,
  BulkUpdateBudgetAllocationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface UseCreateBudgetAllocationProps {
  budgetId: number
}

interface UseDeleteBudgetAllocationProps {
  budgetId: number
}

interface UseUpdateBudgetAllocationProps {
  budgetId: number
}

export const useCreateBudgetAllocation = ({ budgetId }: UseCreateBudgetAllocationProps) => {
  const [createBudgetAllocation, { loading }] = useMutation(BulkCreateBudgetAllocationDocument, {
    extractorFn: (data) => data.financeMutations.bulkCreateFinanceBudgetAllocation,
    refetchQueries: [],
  })

  return {
    loading,
    createBudgetAllocation: (variables: BulkCreateBudgetAllocationMutationVariables) =>
      createBudgetAllocation({ variables }),
  }
}

export const useBulkUpdateBudgetAllocation = ({ budgetId }: UseUpdateBudgetAllocationProps) => {
  const [bulkUpdateBudgetAllocation, { loading }] = useMutation(
    BulkUpdateBudgetAllocationDocument,
    {
      extractorFn: (data) => data.financeMutations.bulkUpdateFinanceBudgetAllocation,
      refetchQueries: [],
    }
  )

  return {
    loading,
    bulkUpdateBudgetAllocation: (variables: BulkUpdateBudgetAllocationMutationVariables) =>
      bulkUpdateBudgetAllocation({ variables }),
  }
}

export const useDeleteBudgetAllocation = ({ budgetId }: UseDeleteBudgetAllocationProps) => {
  const [deleteBudgetAllocation, { loading }] = useMutation(BulkDeleteBudgetAllocationDocument, {
    extractorFn: (data) => data.financeMutations.bulkDeleteFinanceBudgetAllocation,
    refetchQueries: [],
  })
  return {
    loading,
    deleteBudgetAllocation: (variables: BulkDeleteBudgetAllocationMutationVariables) =>
      deleteBudgetAllocation({ variables }),
  }
}
